import Vue from 'vue';
import JQuery from 'jquery';
import isFunction from 'lodash/isFunction';
import uniq from 'lodash/uniq';
import map from 'lodash/map';
import get from 'lodash/get';

export const updateTableHeight = () => {
  let maxHeight = 300;
  const headerFooterHeight = 450;
  const newHeight = JQuery(window).height() - headerFooterHeight;

  if (newHeight > maxHeight) {
    maxHeight = newHeight;
  }

  Vue.$logger.debug('updateTableHeight#set maxHeight', maxHeight);
  JQuery('.table-auto-height').css('max-height', `${maxHeight}px`);
};

export const resourcesFiltered = (resources, fields, footFilters) => {
  const items = resources.filter((item) => {
    let keep = true;

    footFilterableColumns(fields).forEach((column) => {
      const columnFilterData = get(footFilters, [column.key, 'value']);

      // keep value 0, in javascript 0 equal with false
      if (columnFilterData || columnFilterData === 0) {
        let fieldData = isFunction(column.footOptions) ? column.footOptions(item[column.key]) : item[column.key];

        keep = keep && fieldData === columnFilterData;
      }
    });

    return keep;
  });

  return items;
};

export const tableFootOptions = (resources, fields) => {
  const options = {};

  footFilterableColumns(fields).forEach((column) => {
    let values = resources.map((item) =>
      isFunction(column.footOptions) ? column.footOptions(item[column.key]) : item[column.key]
    );

    // Using Array from with Set to uniq values
    values = map(uniq(values), (item) => {
      return { label: item, value: item };
    });

    options[column.key] = values;
  });

  return options;
};

// PRIVATE

const footFilterableColumns = (fields) => {
  return fields.filter((field) => field.enable == true && field.footFilterable == true);
};
